import { useState } from "react"
import IllustrationResultsTable from "../../components/IllustrationResultsTable"
import useIllustrationResult from "../../hooks/useIllustrationResult"
import usePagination from "../../hooks/usePagination"
import { generateFilter } from "../../utils"
import ApiError from "../../components/ApiError"

const Illustrations = () => {
  const { limit, onPaginationChange, page, pagination } = usePagination()
  const [sorting, setSorting] = useState([{ id: "createdAt", desc: true }])
  const [filters, setFilters] = useState([])

  const { data, isLoading, error, isError } = useIllustrationResult({
    page,
    limit,
    sortBy: sorting.map((s) => `${s.id}:${s.desc ? "DESC" : "ASC"}`).join(","),
    filters: generateFilter(filters),
  })

  if (isError) {
    return (
      <div className="mt-4">
        <ApiError axiosError={error} />
      </div>
    )
  }

  return (
    <div>
      <IllustrationResultsTable
        data={isLoading ? [] : data.data}
        filters={filters}
        loading={isLoading}
        pageCount={isLoading ? 0 : data.pages}
        pagination={pagination}
        setFilters={setFilters}
        setSorting={setSorting}
        sorting={sorting}
        onPaginationChange={onPaginationChange}
      />
    </div>
  )
}

export default Illustrations
